import { useState, useCallback, useRef, useEffect } from 'react'
import {
  GoogleMap,
  Polygon,
  Marker,
  useJsApiLoader
} from '@react-google-maps/api'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Div from '@ui/layout/Div'
import { useNavigate } from 'react-router'
import { ROLE_PUBLIC } from '@router/Routes'
import CompanySterilizationCallBuildingsMapManager from './CompanySterilizationCallBuildingsMapManager'

const containerStyle = {
  width: '100%',
  height: '600px'
}

const CompanySterilizationCallBuildings = () => {
  const { mission } = useSelector(state => state.main)
  const [t] = useTranslation('sterilization')
  const [activeBuilding, setActiveBuilding] = useState({ path: [], area: 0, name: '', key: Math.random().toString(36).substring(2, 7) })
  const { path } = activeBuilding
  const mapRef = useRef()
  const navigate = useNavigate()

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: import.meta.env.VITE_MAPS_KEY,
    libraries: ['geometry']
  })

  const onMapClick = useCallback((e) => {
    setActiveBuilding(prev => {
      return {
        ...prev, path: [...prev.path, {
          lat: e.latLng.lat(),
          lng: e.latLng.lng()
        }]
      }
    })
  }, [])

  const onLoad = useCallback((map) => {
    mapRef.current = map
  }, [])

  const onUnmount = useCallback(() => {
    mapRef.current = null
  }, [])

  useEffect(() => {
    if (!window.sessionStorage.getItem('lastCompanyCall') || 'undefined' === typeof window.sessionStorage.getItem('lastCompanyCall')) {
      navigate(ROLE_PUBLIC['home'])
    }
  })

  return isLoaded ? (
    <Div cssClass='buildings-area'>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={mission.coordinates}
        zoom={14}
        onClick={onMapClick}
        onLoad={onLoad}
        onUnmount={onUnmount}
        mapTypeId='hybrid'
      >
        {path.length > 0 && (
          <Polygon
            paths={path}
            options={{
              strokeColor: '#FF0000',
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: '#FF0000',
              fillOpacity: 0.35
            }}
          />
        )}

        {path.map((position, idx) => (
          <Marker
            key={idx}
            position={position}
            label={{
              text: (idx + 1).toString(),
              color: 'white',
              fontSize: '12px'
            }}
            icon={{
              path: window.google.maps.SymbolPath.CIRCLE,
              scale: 7,
              fillColor: 'red',
              fillOpacity: 1,
              strokeWeight: 1
            }}
          />
        ))}
      </GoogleMap>

      <CompanySterilizationCallBuildingsMapManager activeBuilding={activeBuilding} setActiveBuilding={setActiveBuilding} />
    </Div>
  ) : <Div>{t('messages.loading_map')}</Div>
}

export default CompanySterilizationCallBuildings
